<div id="app-version">
    Version: {{version}}
</div>
